﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";
/*import * as $ from "jquery";*/
import './jquery';
import "jquery-mask-plugin";
import "jquery-validation"
import "jquery-validation-unobtrusive";
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import { SignatureWidget } from "./signature";

export class NoLoginDenyWidget {
    private element: HTMLElement;
    private service: Service;
    private statusBarWidget: StatusBarWidget;
    private debug: boolean = true;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;
        this.init();
    }

    init() {
        let th = this;     
        $(th.element).find("#form").on("submit", (ev: Event) => th.submitDenial(ev));       
        //$('[data-name=btnSubmitDenial]').off();
        //$('[data-name=btnSubmitDenial]').on("click", (ev: Event) => th.submitDenial(ev));
    }
    async submitDenial(ev: Event) {
        ev.preventDefault();
        var th = this;
        this._showLoader();
        this._debugging("submitting documents");
          
        let url = (ev.currentTarget as HTMLFormElement).action;
        let formElement = $(ev.target).closest("form");
        this._debugging(formElement);
        let el = $(`.table-wrap.signt`);
        let inputField = $(formElement).find("input[name='RazlogZavrnitve']");


        //unobtrusive
        formElement.validate();
        $.validator.messages.required = inputField.attr("errormessage");
        $(inputField).rules('add', { required: true });
        if (!formElement.valid()) {
            this._hideLoader();
            return false;
        }

        let data = formElement.serializeArray();

        this._debugging("showing loader");
        th._showLoader();

        this._debugging("ready to post");
        this._debugging(data);

        // make ajax call
        $.ajax({
            method: "POST",
            url: url,
            data: data,
            cotnetType: "multipart/form-data",
            dataType: "json",
            async: false,
            success: function (data) {
                if (data.success) {
                    if (data.redirectUrl != null && data.redirectUrl != "") {
                        window.location.href = data.redirectUrl;
                    }
                    else {
                        th.statusBarWidget.setStatus(data.message, "ok");
                        th._hideLoader();
                        return;
                    }
                }
                else {
                    th.statusBarWidget.setStatus(data.message, "bad");
                    th._hideLoader();
                }                
            },
            error: function (xhr, status, error) {
                th.statusBarWidget.setStatus("status: " + status + " error: " + error, "bad");
                th._hideLoader(); 
            }
        });
    }      

    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
}
